var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "df1aac29ebc215decce0ab2784231b91",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.072,
    height: 68.072,
    viewBox: "0 0 68.072 68.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_168059",
    "data-name": "Path 168059",
    d: "M0,0H68.072V68.072H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168060",
    "data-name": "Path 168060",
    d: "M17.942,32.083l8.027-8.027L8.412,6.527a2.853,2.853,0,0,0-4.567.766A11.391,11.391,0,0,0,6.058,20.227Zm19.23-5.134c4.34,2.014,10.438.6,14.948-3.914,5.417-5.417,6.467-13.189,2.3-17.358-4.141-4.141-11.913-3.12-17.358,2.3-4.51,4.51-5.928,10.608-3.914,14.948l-25.7,25.7a2.828,2.828,0,1,0,4,4L29,35.118,46.533,52.646a2.828,2.828,0,1,0,4-4L33,31.119l4.169-4.169Z",
    transform: "translate(5.032 5.754)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantQuestion);
export default __webpack_public_path__ + "static/media/restaurant-question.a4d35c9b8707257ed2eef96ad89359a2.svg";
export { ForwardRef as ReactComponent };